module.exports = __webpack_public_path__ + "img/wirenetwork.e30a9746.svg";